<template>
  <v-container>
    <v-row>
      <v-col cols="4" v-for="qbCall in customerCalls">
        <v-card class="pa-2" outlined tile>
          <h3 class="text-center">{{ qbCall.uuid }}</h3>
          <p class="text-center">
            {{ formatEpochDate(qbCall.queue_start_epoch) }}
          </p>
          <p class="text-center">
            <v-btn elevation="2" x-small @click="clearCallFunc(qbCall)"
              >Clear Call</v-btn
            >
          </p>
          <json-viewer
            :value="qbCall"
            :expand-depth="0"
            copyable
            boxed
            sort
          ></json-viewer>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import JsonViewer from "vue-json-viewer";

Vue.use(JsonViewer);

export default {
  props: ["customerCalls", "clearCall"],

  methods: {
    formatEpochDate(epoch) {
      return new Date(parseInt(epoch) * 1000).toLocaleString();
    },
    clearCallFunc(qbCall) {
      this.clearCall(qbCall);
    },
  },
};
</script>
